export default {
    data: () => ({
        curTitleIdx: 0,
        data: {},
        renderLs: [],
    }),
    watch: {
        '$route': {
            handler: function () {
                this.$nextTick(() => {
                    let id = this.getId()
                    if (id === false) {
                        return
                    }
                    this.curTitleIdx = id
                    this.genRenderLs(id)
                })
            },
            immediate: true
        }
    },
    created () {
        this.data = this.$store.getters.getIndexData[this.type + 'Enum']
    },
    methods: {
        changeTitle (idx) {
            this.$router.push(`/${this.type}/${idx}`)
        },
        genRenderLs (idx) {
            let params = {}
            params[this.type + 'EnumId'] = this.data[idx].id
            this.$$$api[this.type](params).then(res => {
                this.renderLs = res.data.data[this.type] 
            })
        },
        getId () {
            if (location.href.match('lawerDetail')) {
                return false
            }

            return +this.$route.path[this.$route.path.length - 1]
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common.js